@if (formControl) {
    @if((formControl?.value || '').length > 0 && inputFocused){
        <div class="search-content">
            @if(patients.length > 0){
                @for (patient of patients; track patient.id) {
                    <a class="search-suggestion" (click)="patientClicked(patient.id)">
                        {{patient.firstname}} {{patient.lastname.toUpperCase()}}
                        <fa-icon class="suggestion-icon" [icon]="fasUser"></fa-icon>
                    </a>
                }
            }
            @if(consultations.length > 0 ){
                @for (consultation of consultations; track consultation.id) {
                    <a class="search-suggestion" (click)="consultationClicked(consultation.id)">
                        {{consultation.title}}  ---  {{consultation.patient.lastname}} {{consultation.patient.firstname}}
                        <fa-icon class="suggestion-icon" [icon]="fasClipboardList	"></fa-icon>
                    </a>
                }
            }
        </div>
    }
    <hw-text-input (inputFocused)="inputInteracted($event)" [placeholder]="placeholder" [name]="name" [formControl]="formControl" rightIcon="fasMagnifyingGlass"></hw-text-input>
} @else {
    <span class="error">Please Add a FormControl to this input</span>
}
